import { windowPositionOptions } from "../types";
import {
  SelectSystemEnum,
  SelectSystemEnumProps,
} from "@components-common/forms";

export const WindowPositionSelector = ({
  id = "position",
  ...rest
}: SelectSystemEnumProps & {showHelp?: boolean}) => (
  <SelectSystemEnum
    id={id}
    showHelp={false}
    {...rest}
    options={windowPositionOptions}
  />
);
